/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatgroupform', {
      restrict: 'E',
      bindings: {
        privcatgroup: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcfinance/privcat/privcatgroupform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Privcat',
        function ($log, Privcat) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          vm.addPrivcat = addPrivcat;
          vm.getPrivcats = getPrivcats;
          vm.removeEntry = removeEntry;

          vm.$onInit = function () {
            vm.lastprivcatgroup = angular.copy(vm.privcatgroup);
          };

          function save() {
            // $log.debug('saving group: ', vm.privcatgroup);

              vm.lastprivcatgroup = angular.copy(vm.privcatgroup);
              vm.parentsave({privcatgroup: vm.privcatgroup});
            // Those lines failed on adding a new entry to entries hastable
            /*            if (!angular.equals(vm.privcatgroup, vm.lastprivcatgroup)) {
              $log.debug('saving group: ', vm.privcatgroup);
              vm.lastprivcatgroup = angular.copy(vm.privcatgroup);
              vm.parentsave({privcatgroup: vm.privcatgroup});
            }*/
          }

          function cancel() {
            vm.privcatgroup = angular.copy(vm.lastprivcatgroup);
            vm.oncancel();
          }


          // typeahead privcat search backend query
          function getPrivcats(val) {
            return Privcat.$searchahead({
              query: val,
              fields: ['shortcut', 'name']
            }).$asPromise().then(function (response) {
              return response.filter(function (privcat) {
                if (privcat.type === 'entry') {
                  return privcat;
                }
              }).map(function (privcat) {
                privcat.text = privcat.shortcut + ' - ' + privcat.name;
                delete vm.error;
                return privcat;
              });
            });
          }

          // typeahead privcat search action
          function addPrivcat($item, $model, $label) {
            /* jshint unused:false */
            /* eslint "no-unused-lets": [2, {"args": "none"}] */
            vm.privcat = $model;
            vm.privcatref = $model._id;
            delete vm.asyncSelected;

            let privcat = {};
            privcat.name = $model.name;
            privcat.shortcut = $model.shortcut;
            privcat._id = $model._id;
            if (angular.isUndefined(vm.privcatgroup.items)) {
              vm.privcatgroup.items = [];
            }
            vm.privcatgroup.items.push(privcat);
          }


          function removeEntry(i) {
            vm.privcatgroup.items.splice(i,1);
          }

        }] // controller
    }); // component

// klammerfriedhof
}());